<template>
  <div class="w-100">
    <b-col><hr></b-col>
    <b-button
      variant="outline-primary"
      size="sm"
      class="float-right"
      @click="$emit('closeModal')"
    >
      INCHIDE
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'modalFooter'
}
</script>
